<div class="section">
    <div class="section__header">
        <h2 class="section__name">{{props['name']}}</h2>
    </div>
    <ng-container *ngIf="findKeyInJson(summarySection.elements, 'adminOverrideEligible')">
        <div class="admin-override-wrapper">
            <span>Click edit to modify price fields. Only administrators can perform this action.</span>
            <ng-container *ngIf="editing">
                <div class="editing-button-wrapper">
                    <button class="cancel-button" (click)="cancelOverride()">Cancel</button>
                    <button (click)="saveOverride()">Save</button>
                </div>
            </ng-container>
            <ng-container *ngIf="!editing">
                <button class="admin-override-button" (click)="adminOverride()">Edit</button>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngFor="let element of summarySection.elements">
        <ng-container *ngIf="element.type === 352">
            <div class="discount-code-wrapper">
                <strong>Discount Code</strong>
                <span class="discount-code__subtitle">Enter a discount code:</span>
                <ng-container *ngIf="discountCodeResponse.errors.length > 0">
                    <span class="discount-code__error">Invalid discount code</span>
                </ng-container>
                <div class="input-wrapper">
                    <sl-input #discountInput size="small" [value]="element.templateOptions.discountCode" class="discount-code__input"></sl-input>
                    <button class="discount-code__apply" (click)="applyDiscount(discountInput)">Apply</button>
                </div>
                <button class="discount-code__clear" (click)="clearDiscount()">Clear</button>
            </div>
        </ng-container>
        <ng-container *ngIf="element.type === 351">
            <ng-container *ngFor="let section of element.templateOptions.sections">
                <ng-container [ngSwitch]="section.type">
                    <app-summary-event-section *ngSwitchCase="3" [section]="getSectionObject(section)"></app-summary-event-section>
                    <app-summary-membership-section *ngSwitchCase="4" [section]="getSectionObject(section)"></app-summary-membership-section>
                    <app-summary-review-panel-section *ngSwitchCase="9" [section]="getSectionObject(section)"></app-summary-review-panel-section>
                    <app-summary-general-section *ngSwitchDefault [section]="getSectionObject(section)"></app-summary-general-section>
                </ng-container>
                <sl-divider></sl-divider>
            </ng-container>
        </ng-container>
    </ng-container>
    <div class="section__footer" *ngIf="this.props['totalDiscountedAmount'] != 0">
        <strong>Total:</strong>
        <strong>{{getTotal()}}</strong>
    </div>